module.exports = "https://r.zoocdn.com/_next/static/images/favicon-876be118935526ee522f78ec1d50080f.ico";